import { markupTemplateLang } from "./shared"

markupTemplateLang("twig", {
	block: ["{#", "#}"],
})
